import { useState, useEffect, useRef } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import './style.css';
import AlertMessage from '../../components/Alert';
import { CardContent } from '../../components/CardContent';
import { Main } from '../../components/Main';
import { Title } from '../../components/Title';
import { Button, Card, Col, Modal as Modals, Row, Modal as ModalBoot } from 'react-bootstrap';
import { Label } from '../../components/Label';
import api from '../../services/api';
import { Autocomplete, Modal, Box, LinearProgress, TextField, Typography, Tooltip } from '@mui/material';
import { AsoRapido } from '../../components/Reaproveitamentos/AsoRapido';
import { ModalAsoTrabalhador } from '../../components/Reaproveitamentos/ModalAsoTrabalhador';
import { AsoPcmso } from '../../components/Reaproveitamentos/AsoPcmso';
import { AsoPronto } from '../../components/Reaproveitamentos/AsoPronto';

const ReaproveitamentoAsoCadastrar = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [trabalhadores, setTrabalhadores] = useState([]);
    const [trabalhador, setTrabalhador] = useState([]);
    const [fdts, setFdts] = useState([]);
    const [examesCadastrados, setExamesCadastrados] = useState([]);
    const [trabalhadorSelecionado, setTrabalhadorSeelcionado]: any = useState(null);
    const [fdtSelecionado, setFdtSelecionado]: any = useState(null);
    const [empresa, setEmpresa]: any = useState(null);
    const [cnae, setCnae]: any = useState(null);
    const [show, setShow] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [preco, setPreco]: any = useState(0);
    const [idEmpresa, setIdEmpresa]: any = useState(null);
    const [error, setError] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [valorInicialTotal, setValorInicialTotal] = useState(0);
    const [redirectCounter, setRedirectCounter] = useState(5);
    const [modeloSelecionado, setModeloSelecionado] = useState('');

    // States para o modal de envio de documentos pelo trabalhador - transformar em componente depois
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleModeloClick = (buttonName: any) => {
        setModeloSelecionado(buttonName);
    };

    useEffect(() => {
        const calcularValorInicial = () => {
            const somaValores = parseFloat(examesCadastrados
                .reduce((total: number, exame: { valor_total: number }) => total + exame.valor_total / 100, 0)
                .toFixed(2));
            setValorInicialTotal(somaValores);
        };

        // Apenas calcula o valor inicial na primeira carga
        if (examesCadastrados.length > 0 && valorInicialTotal === 0) {
            calcularValorInicial();
        }
    }, [examesCadastrados]);

    const handleSearchProduct = async () => {
        try {
            const response = await api.post('buscar-produto-reaproveitamento-empresa')
            setPreco(response.data.preco)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        handleSearchProduct();
    }, []);

    useEffect(() => {
        handleListCompany();
    }, [trabalhadores]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseTrabalhadores = await api.get(`buscar-trabalhador/null`);
                setTrabalhadores(responseTrabalhadores.data.trabalhadores);

                const responseFdts = await api.get(`buscar-fdt-por-input/null`);
                setFdts(responseFdts.data.fdts);

            } catch (error) {
                console.error('Erro ao buscar dados iniciais', error);
                setAlert({ show: true, message: 'Erro ao buscar dados iniciais. Tente novamente!', variant: 'danger' });
            }
        };
        fetchData();
    }, [fdtSelecionado]);

    const handleListWorker = async (inputValue: string | any[]) => {
        if (inputValue.length === 0) {
            setTrabalhadores(trabalhadores);
        } else if (inputValue.length > 0) {
            try {
                const response = await api.get(`buscar-trabalhador/${inputValue}`);
                setTrabalhador(response.data.trabalhador);
                setTrabalhadores(response.data.trabalhadores);
            } catch (error) {
                console.error('Erro ao buscar trabalhador', error);
                setAlert({ show: true, message: 'Erro ao buscar trabalhador. Tente novamente!', variant: 'danger' });
            }
        } else {
            setTrabalhadores([]);
        }
    };


    const handleCloseErrorModal = () => setShowErrorModal(false);

    const handleListCompany = async () => {
        try {
            const response = await api.post('listar-empresa-aso');

            setEmpresa(response.data.empresa);
            setIdEmpresa(response.data.empresa.id);
            setCnae(response.data.cnae);

        } catch (error) {
            console.log(error)
        }
    }

    const getButtonStyle = (modelo: any) => {
        return {
            width: '60%',
            backgroundColor: modeloSelecionado === modelo ? '#003366' : '#0463C1',
            borderColor: modeloSelecionado === modelo ? '#003366' : '#0463C1',
            color: '#fff',
        };
    };

    return (
        <>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Title text='Reaproveitar ASOS'></Title>
                <div style={{
                    display: 'flex',
                    height: 'auto',
                    padding: '10px'
                }}>
                    <CardContent style={{ width: '50%', padding: '20px', textAlign: 'center' }}>
                        <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                            1º - Buscar Trabalhador por CPF
                        </h5>
                        <Row>
                            <Col xs={12}>
                                <Autocomplete
                                    value={trabalhadorSelecionado}
                                    onChange={(event, newValue) => {
                                        setTrabalhadorSeelcionado(newValue);
                                        setModeloSelecionado('')
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        handleListWorker(newInputValue);
                                    }}
                                    noOptionsText="Digite e selecione"
                                    style={{ width: '100%', marginBottom: '20px' }}
                                    getOptionLabel={(option) =>
                                        option ? `${option.cpf} - ${option.nome}` : ""
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} label="Buscar por CPF" />
                                    )}
                                    options={trabalhadores.length > 0 ? trabalhadores : []}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </Col>
                        </Row>
                        <span>
                            Caso não tenha encontrado o reaproveitamento do trabalhador , <button onClick={handleShowModal} style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                                clique aqui para cadastrar o documento ASO dele.
                            </button>
                        </span>
                    </CardContent>
                </div>

                {trabalhadorSelecionado && (
                    <div style={{
                        display: 'flex',
                        height: 'auto',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '10px'
                    }}>
                        <CardContent style={{ width: '50%', padding: '20px', textAlign: 'center' }}>
                            <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                                2º - Selecione o modelo de Reaproveitamento que deseja:
                            </h5>
                            <Row className="justify-content-center" style={{ marginTop: '10px' }}>
                                <Col xs={12} md={4} className="d-flex justify-content-center" style={{ marginBottom: '10px' }}>
                                    <Button
                                        style={getButtonStyle('ASO Pronto')}
                                        onClick={() => handleModeloClick('ASO Pronto')}
                                    >
                                        ASO Pronto
                                    </Button>
                                </Col>
                                <Col xs={12} md={4} className="d-flex justify-content-center" style={{ marginBottom: '10px' }}>
                                    <Button
                                        style={getButtonStyle('ASO Rápido')}
                                        onClick={() => handleModeloClick('ASO Rápido')}
                                    >
                                        ASO Rápido
                                    </Button>
                                </Col>
                                <Col xs={12} md={4} className="d-flex justify-content-center" style={{ marginBottom: '10px' }}>
                                    <Button
                                        style={getButtonStyle('ASO por PCMSO')}
                                        onClick={() => handleModeloClick('ASO por PCMSO')}
                                    >
                                        ASO por PCMSO
                                    </Button>
                                </Col>
                            </Row>
                        </CardContent>
                    </div>
                )}

                {(trabalhadorSelecionado && modeloSelecionado !== '') && (
                    <>
                        {modeloSelecionado === 'ASO Rápido' && (
                            <>
                                <AsoRapido
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    cnae={cnae}
                                />
                            </>
                        )}

                        {modeloSelecionado === 'ASO Pronto' && (
                            <>
                                <AsoPronto
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    cnae={cnae}
                                />
                            </>
                        )}

                        {modeloSelecionado === 'ASO por PCMSO' && (
                            <>
                                <AsoPcmso
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    cnae={cnae}
                                />
                            </>
                        )}
                    </>

                )}
            </Main>

            {showModal && (
                <ModalAsoTrabalhador
                    idEmpresa={idEmpresa}
                    show={showModal}
                    onHide={handleCloseModal}
                />
            )}


            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />

            <Modals show={showErrorModal} onHide={handleCloseErrorModal}>
                <Modals.Body>Preencha todos os campos obrigatórios antes de prosseguir.</Modals.Body>
                <Modals.Footer>
                    <Button variant="secondary" onClick={handleCloseErrorModal}>
                        Fechar
                    </Button>
                </Modals.Footer>
            </Modals>
        </>
    );
}

export default ReaproveitamentoAsoCadastrar;
